/*
 * Copyright © 2016-2020 The Thingsboard Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
export default angular.module('thingsboard.api.self-registration', [])
    .factory('selfRegistrationService', selfRegistrationService)
    .name;

/*@ngInject*/
function selfRegistrationService($http, $q, $rootScope, $state) {

    var service = {
        getRegistrationLink: getRegistrationLink,
        isAvailablePage: isAvailablePage,
        loadSelfRegistrationParams: loadSelfRegistrationParams,
        loadPrivacyPolicy: loadPrivacyPolicy,
        saveSelfRegistrationParams: saveSelfRegistrationParams,
        getSelfRegistrationParams: getSelfRegistrationParams
    };

    return service;

    function getRegistrationLink(domainName) {
        return domainName + "/signup";
    }

    function loadSelfRegistrationParams() {
        var deferred = $q.defer();
        var url = '/api/noauth/selfRegistration/signUpSelfRegistrationParams';
        $http.get(url, null).then(function success(response) {
            $rootScope.signUpParams = response.data;
            $rootScope.signUpParams.activate = $rootScope.signUpParams.captchaSiteKey !== null;
            deferred.resolve();
        }, function fail() {
            deferred.reject();
        });
        return deferred.promise;
    }

    function loadPrivacyPolicy() {
        var deferred = $q.defer();
        var url = '/api/noauth/selfRegistration/privacyPolicy';
        $http.get(url, null).then(function success(response) {
            deferred.resolve(response.data);
        }, function fail() {
            deferred.reject();
        });
        return deferred.promise;
    }

    function isAvailablePage(){
        var deferred = $q.defer();
        if($rootScope.signUpParams){
            $rootScope.signUpParams.activate ? deferred.resolve():$state.go('login');
        } else {
            loadSelfRegistrationParams().then(function success(){
                $rootScope.signUpParams.activate ? deferred.resolve():$state.go('login');
            });
        }
        return deferred.promise;
    }

    function saveSelfRegistrationParams(selfRegistrationParams) {
        var deferred = $q.defer();
        var url = '/api/selfRegistration/selfRegistrationParams';
        $http.post(url, selfRegistrationParams).then(function success() {
            deferred.resolve();
        }, function fail() {
            deferred.reject();
        });
        return deferred.promise;
    }

    function getSelfRegistrationParams() {
        var deferred = $q.defer();
        var url = '/api/selfRegistration/selfRegistrationParams';
        $http.get(url, null).then(function success(response) {
            deferred.resolve(response.data);
        }, function fail() {
            deferred.reject();
        });
        return deferred.promise;
    }
}